import {AxiosResponse} from "axios";
import AxiosApiInstance, {APIBase} from "../AxiosApiInstance";
import {ApiRecommendationModel} from "./ApiRecommendationModel";

export const ApiRecommendationsGet: (id:string) => Promise<AxiosResponse<ApiRecommendationModel>> = (id) => {
  return AxiosApiInstance.get(`${APIBase}recommendations/${id}/`);
};